import React from "react";
import logoREAL from "../../../../assets/images/logo_REAL.png";
import logo_root_header from "../../../../assets/images/logo_root_header.png";
import logo_watermark from "../../../../assets/images/logo_watermark.png";

import "./index.css";

function GroupCovers({ groupinfo }) {
  return (
    <div className="GroupCovers page">
      <div className="cover-container">
        <div className="top-half"></div>
        <div className="bottom-half"></div>
        <div className="dashboard-text">TEAM DASH BOARD</div>

        <img src={logoREAL} alt="Logo" className="logo-real" />
        <img src={logo_root_header} alt="Logo" className="logo-root" />
        <div className="more-info">
          <b>PRIVATE AND CONFIDENTIAL</b>
          <p>
            This document is for the authorized team only and requires prior
            approval for use
          </p>
          <p>이 문서는 승인된 팀만 사용할 수 있으며, 사전 승인이 필요합니다.</p>
          <p>RootConsulting 2024.All right Reserved.</p>
        </div>
        <div className="Group-text">Report for</div>
        <div className="watermark-container">
          <img src={logo_watermark} alt="Logo" className="logo-watermark" />
          <div className="info-text">
            <p>
              <b>
                {groupinfo.companyname} {groupinfo.groupname}
              </b>
            </p>
            <p>
              <b>{groupinfo.date}</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupCovers;
